export default __webpack_public_path__ + "static/media/Hogan.be41b60e.png";